export default __webpack_public_path__ + "static/media/poster-pabllo-mobile.b1fe5df6.png";